"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateHash = void 0;
const viem_1 = require("viem");
/**
 * Generates a hash from the given input string and truncates it to the specified size.
 *
 * @param {string} input - The input string to be hashed.
 * @param {number} size - The number of bytes to take from the end of the hash.
 * @returns {string} A hexadecimal string representation of the truncated hash, without the `0x` prefix.
 */
function generateHash(input, size) {
    const fullHash = (0, viem_1.keccak256)((0, viem_1.toHex)(input));
    return (0, viem_1.toHex)(fullHash.slice(-size)).replace('0x', ''); // Take the last X bytes
}
exports.generateHash = generateHash;
/**
 * Generates an on-chain identifier for tracking transactions on the blockchain.
 * This identifier includes hashed metadata such as the project name, platform, tool, and tool version.
 *
 * @param {Object} params - An object containing the metadata for generating the on-chain identifier.
 * @param {string} params.project - The name of the project initiating the transaction.
 * @param {string} [params.platform='Web'] - The platform from which the transaction originates (e.g., "Web", "Mobile", "Safe App", "Widget"...).
 * @param {string} params.tool - The tool used to generate the transaction (e.g., "protocol-kit").
 * @param {string} params.toolVersion - The version of the tool used to generate the transaction.
 * @returns {string} A string representing the on-chain identifier, composed of multiple hashed segments.
 *
 * @example
 * const identifier = generateOnChainIdentifier({
 *   project: 'MyProject',
 *   platform: 'Mobile',
 *   tool: 'protocol-kit',
 *   toolVersion: '4.0.0'
 * })
 */
function generateOnChainIdentifier({ project, platform = 'Web', tool, toolVersion }) {
    const identifierPrefix = '5afe';
    const identifierVersion = '00'; // first version
    const projectHash = generateHash(project, 20); // Take the last 20 bytes
    const platformHash = generateHash(platform, 3); // Take the last 3 bytes
    const toolHash = generateHash(tool, 3); // Take the last 3 bytes
    const toolVersionHash = generateHash(toolVersion, 3); // Take the last 3 bytes
    return `${identifierPrefix}${identifierVersion}${projectHash}${platformHash}${toolHash}${toolVersionHash}`;
}
exports.default = generateOnChainIdentifier;
//# sourceMappingURL=generateOnChainIdentifier.js.map